import React from 'react';
// components
import { TextComponent } from '../../../components/text';
// helpers/constants
import * as G from '../../../helpers';
//////////////////////////////////////////////////

export const TableCell = ({ text, title }) => {
  if (G.isNilOrEmpty(text)) return null;

  return (
    <TextComponent
      maxWidth='90%'
      display='block'
      withEllipsis={true}
      title={title || text}
    >
      {text}
    </TextComponent>
  );
};
